import { render } from "./Vocals.vue?vue&type=template&id=f2bb13d6"
import script from "./Vocals.vue?vue&type=script&lang=js"
export * from "./Vocals.vue?vue&type=script&lang=js"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__